import { Component } from '@angular/core';

@Component({
  selector: 'cabinet',
  templateUrl: './cabinet.component.html',
  styleUrls: ['./cabinet.component.css']
})
export class CabinetComponent {}



// WEBPACK FOOTER //
// /Users/yoann/Perso/Pedicure-Podologue/src/app/cabinet/cabinet.component.ts